import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface HelpModeContextType {
  isHelpMode: boolean;
  enableHelpMode: () => void;
  disableHelpMode: () => void;
  toggleHelpMode: () => void;
}

const HelpModeContext = createContext<HelpModeContextType | null>(null);

interface HelpModeProviderProps {
  children: ReactNode;
}

export const HelpModeProvider: React.FC<HelpModeProviderProps> = ({ children }) => {
  const [isHelpMode, setIsHelpMode] = useState(false);

  const enableHelpMode = useCallback(() => setIsHelpMode(true), []);
  const disableHelpMode = useCallback(() => setIsHelpMode(false), []);
  const toggleHelpMode = useCallback(() => setIsHelpMode((prev) => !prev), []);

  return (
    <HelpModeContext.Provider
      value={{ isHelpMode, enableHelpMode, disableHelpMode, toggleHelpMode }}
    >
      {children}
    </HelpModeContext.Provider>
  );
};

export const useHelpModeContext = (): HelpModeContextType => {
  const context = useContext(HelpModeContext);
  if (!context) {
    throw new Error('useHelpModeContext must be used within HelpModeProvider');
  }
  return context;
};
